import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../images/received_311522469882492.jpeg'
import _imports_1 from '../images/IMG_2332.jpeg'
import _imports_2 from '../images/Amour-Etc.196 (1).jpg'


const _hoisted_1 = { class: "joke-dialog__checkbox" }
const _hoisted_2 = { class: "joke-dialog__footer" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "accueil" }
const _hoisted_5 = { class: "hero" }
const _hoisted_6 = { class: "hero__content" }
const _hoisted_7 = { class: "confirmation" }
const _hoisted_8 = { class: "confirmation__inner" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["Dialog"], {
      visible: $setup.isConfirmationPresenceModalVisible,
      "onUpdate:visible": _cache[1] || (_cache[1] = $event => (($setup.isConfirmationPresenceModalVisible) = $event)),
      header: "Confirmation de votre présence",
      modal: "",
      onAfterHide: $setup.resetModelValue
    }, {
      default: _withCtx(() => [
        _createVNode($setup["PresenceForm"], {
          modelValue: $setup.confirmationPresence,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.confirmationPresence) = $event)),
          onSubmitted: $setup.onFormSubmitted
        }, null, 8 /* PROPS */, ["modelValue"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible"]),
    _createVNode($setup["Dialog"], {
      visible: $setup.showJokeDialog,
      "onUpdate:visible": _cache[3] || (_cache[3] = $event => (($setup.showJokeDialog) = $event)),
      header: "Merci !",
      modal: "",
      closable: false
    }, {
      default: _withCtx(() => [
        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "joke-dialog__text" }, " Votre réponse a bien été enregistrée. ", -1 /* CACHED */)),
        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "joke-dialog__text" }, " Une dernière formalité… ", -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_1, [
          _createVNode($setup["Checkbox"], {
            modelValue: $setup.jokeAccepted,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.jokeAccepted) = $event)),
            "input-id": "joke_accept",
            binary: ""
          }, null, 8 /* PROPS */, ["modelValue"]),
          _cache[6] || (_cache[6] = _createElementVNode("label", {
            for: "joke_accept",
            class: "joke-dialog__label"
          }, " Je certifie ne pas venir habillé(e) en blanc ", -1 /* CACHED */))
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "btn",
            disabled: !$setup.jokeAccepted,
            onClick: $setup.onJokeConfirm
          }, " J'accepte les conditions ", 8 /* PROPS */, _hoisted_3)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible"]),
    _createElementVNode("div", _hoisted_4, [
      _createCommentVNode(" Hero Section "),
      _createElementVNode("section", _hoisted_5, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "hero__overlay" }, null, -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_6, [
          _cache[9] || (_cache[9] = _createElementVNode("h1", { class: "hero__title" }, " Elena & Antoine ", -1 /* CACHED */)),
          _cache[10] || (_cache[10] = _createElementVNode("h1", { class: "hero__subtitle" }, " Nous allons nous marier ! ", -1 /* CACHED */)),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "hero__divider" }, null, -1 /* CACHED */)),
          _cache[12] || (_cache[12] = _createElementVNode("p", { class: "hero__details" }, [
            _createTextVNode(" Nous nous dirons oui le "),
            _createElementVNode("strong", null, "samedi 13 juin 2026"),
            _createTextVNode(","),
            _createElementVNode("br"),
            _createTextVNode(" au Château du Vivier, à Fontenay-Trésigny (77). ")
          ], -1 /* CACHED */)),
          _createElementVNode("button", {
            class: "btn",
            onClick: _cache[4] || (_cache[4] = $event => ($setup.isConfirmationPresenceModalVisible = true))
          }, " Confirmez votre présence ")
        ])
      ]),
      _createCommentVNode(" Notre histoire "),
      _cache[15] || (_cache[15] = _createStaticVNode("<section class=\"histoire\" data-v-fc9f4435><div class=\"histoire__inner\" data-v-fc9f4435><h2 class=\"histoire__title\" data-v-fc9f4435> Elena &amp; Antoine </h2><p class=\"histoire__subtitle\" data-v-fc9f4435> Notre histoire </p><p class=\"histoire__intro\" data-v-fc9f4435> Le coup de foudre, cela n&#39;arrive pas que dans les films ! </p><div class=\"histoire__timeline\" data-v-fc9f4435><div class=\"histoire__moment\" data-v-fc9f4435><div class=\"histoire__photo-wrap\" data-v-fc9f4435><img src=\"" + _imports_0 + "\" alt=\"Elena &amp; Antoine\" class=\"histoire__photo\" data-v-fc9f4435></div><div class=\"histoire__text\" data-v-fc9f4435><p class=\"histoire__date\" data-v-fc9f4435> 4 décembre 2018 </p><p data-v-fc9f4435>Il murmure un « je t&#39;apprécie » avec pudeur, le sourire aux lèvres comme pour me dire un premier « je t&#39;aime »</p></div></div><div class=\"histoire__moment histoire__moment--reverse\" data-v-fc9f4435><div class=\"histoire__photo-wrap\" data-v-fc9f4435><img src=\"" + _imports_1 + "\" alt=\"Elena &amp; Antoine\" class=\"histoire__photo\" data-v-fc9f4435></div><div class=\"histoire__text\" data-v-fc9f4435><p class=\"histoire__date\" data-v-fc9f4435> 18 août 2024 </p><p data-v-fc9f4435>Elle me répond « oui » au soleil levant, les yeux mouillés, en haut des falaises de l&#39;Algarve</p></div></div><div class=\"histoire__moment\" data-v-fc9f4435><div class=\"histoire__photo-wrap\" data-v-fc9f4435><img src=\"" + _imports_2 + "\" alt=\"Elena &amp; Antoine\" class=\"histoire__photo\" data-v-fc9f4435></div><div class=\"histoire__text\" data-v-fc9f4435><p class=\"histoire__date\" data-v-fc9f4435> 13 juin 2026 </p><p data-v-fc9f4435>Nous nous dirons « je le veux » les yeux dans les yeux, et célébrerons notre union à vos côtés</p></div></div></div></div></section>", 1)),
      _createCommentVNode(" Confirmation CTA "),
      _createElementVNode("section", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[14] || (_cache[14] = _createElementVNode("p", null, "Pour nous aider à finaliser l'organisation, merci de répondre au petit questionnaire ci-dessous.", -1 /* CACHED */)),
          _createElementVNode("button", {
            class: "btn",
            onClick: _cache[5] || (_cache[5] = $event => ($setup.isConfirmationPresenceModalVisible = true))
          }, " Confirmez votre présence ")
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}